import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CmsConfig, ConfigModule, I18nModule } from '@spartacus/core';
import { PaymentInformationComponent } from './payment-information/payment-information.component';
import { SavedCardIframeComponent } from './saved-card-iframe/saved-card-iframe.component';
import { RouterModule } from '@angular/router';



@NgModule({
  declarations: [PaymentInformationComponent, SavedCardIframeComponent],
  imports: [
    CommonModule,
    RouterModule,
    I18nModule,
    ConfigModule.withConfig({
      cmsComponents: {
        SeqirusPaymentInformationComponent :{
          component: PaymentInformationComponent,
      },
      SavedPaymentInfoFlexComponent:{
        component: SavedCardIframeComponent,
      }
    }
  }as CmsConfig)
  ]
})
export class PaymentInfoModule { }
